(function () {
	const sub_menu_els = document.querySelectorAll(`.nav-primary .sub-menu-2`);

	let max_height = 0;
	for (const sub_menu_el of sub_menu_els) {
		const height = sub_menu_el.offsetHeight;

		if (height > max_height) {
			max_height = height;
		}
	}

	document.documentElement.style.setProperty(`--sh-menu-height`, `${max_height}px`);
})();

(function () {
	const button_el = document.querySelector(`.btn-menu`);
	if (!button_el) {
		return;
	}

	function toggle() {
		document.body.classList.toggle(`menu-open`);
	}

	button_el.addEventListener(`click`, toggle);
})();

(function () {
	const dropdown_els = document.querySelectorAll(`.nav-primary .icon-wrapper`);

	function on_click(e) {
		if (window.innerWidth > 1080) {
			return;
		}

		e.preventDefault();

		const parent_el = e.target.closest(`.menu-item`);
		if (!parent_el) {
			return;
		}

		const is_open = parent_el.classList.contains(`open`);

		for (const sibling_el of parent_el.parentNode.children) {
			sibling_el.classList.remove(`open`);
		}

		if (!is_open) {
			parent_el.classList.add(`open`);
		}
	}

	for (const dropdown_el of dropdown_els) {
		dropdown_el.addEventListener(`click`, on_click);
	}
})();
